import { FUZZY_REQUEST, FUZZY_SUCCESS, FUZZY_ERROR, FUZZY_CLEAR } from 'constants/ActionTypes';
import { Core } from 'managers';
import { createAction } from 'actions/utils';

function transformData(data = []) {
    return data.map((item) => ({
        ...item,
        value: item.id,
        label: item.description,
    }));
}

export function clearFuzzy(entity, field) {
    return (dispatch) => {
        dispatch({
            type: FUZZY_CLEAR,
            entity,
            field,
        });
    };
}

export function getFuzzy({ list, text, count }) {
    return (dispatch, getState) => {
        // Check if we have value already
        const state = getState().fuzzy;
        if (
            state &&
            state[list] &&
            state[list].data.length > 0 &&
            state[list].text === text &&
            state[list].count === count
        ) {
            return Promise.resolve(state[list].data);
        }
        return new Promise((resolve, reject) => {
            dispatch(
                createAction(FUZZY_REQUEST, {
                    list,
                    text,
                    count,
                }),
            );
            Core.searchManager.autoCompleteSearch(list, text, count).then(
                (data) => {
                    const finalData = transformData(data);
                    dispatch(
                        createAction(FUZZY_SUCCESS, {
                            list,
                            text,
                            count,
                            data: transformData(data),
                        }),
                    );
                    resolve(finalData);
                },
                (error) => {
                    dispatch(
                        createAction(FUZZY_ERROR, {
                            error: true,
                            errorType: error,
                        }),
                    );
                    reject(error);
                },
            );
        });
    };
}
